// @flow

import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import Text from 'app/common/react/components/common/ExperimentalLegoGestalt/Text';
import { Box } from 'gestalt';
import { type CloseupViewType } from 'app/common/react/components/closeup/types';
import { getNameToShow, getTimeSinceText } from 'app/common/react/components/Activities/common';

type Props = {|
  commentId: string,
  createdAt: string,
  user: Object,
  variant: CloseupViewType,
|};

function CommentAttribution({ createdAt, commentId, user, variant }: Props) {
  const timestampText = (
    <Text color="gray" size="sm">
      {getTimeSinceText(createdAt)}
    </Text>
  );
  return (
    <Box display="flex" alignItems="start" marginStart={-1} marginEnd={-1}>
      <Box paddingX={1}>
        <NavigateLink to={`/${user.username}/`}>
          <Text size="sm" weight={variant === 'default' ? 'semibold' : 'bold'}>
            {getNameToShow(user)}
          </Text>
        </NavigateLink>
      </Box>
      <Box paddingX={1}>{timestampText}</Box>
    </Box>
  );
}

export default CommentAttribution;
